import { useContext } from "react"
import { ModalsContext } from "../ui/ModalsProvider"
import { UseModalsProviderHook } from "../types"

export const useModalsContext = (): UseModalsProviderHook => {
  return useContext(ModalsContext)
}
